export default "__VITE_ASSET__41e5d09c__"